<EmptyHeader></EmptyHeader>
<div class="g-suite-login--main-wrapper">
  {#if $store.isInitialised}
    {#if !$store.isUserSignedIn}
      <span class="sign-in-text">{$store.i18n.SignInToConsent}</span>
    {/if}
  {/if}
  
  {#if $store.isLoading}
    <div class="g-suite-login--loading-spinner"></div>
  {/if}
  
  {#if !$store.isRedirecting}
    <SignInButton />
  {/if}
  
  {#if $store.isLoadCompleted && $store.errorCode == 0}
    <span class="redirecting-text">{$store.i18n.RedirectingToItslearning}</span>
  {/if}
</div>

<script>
    import EmptyHeader from '@itslearning/prometheus/assets/nodes/EmptyHeader/v1/EmptyHeader.svelte';
    import SignInButton from './SignInButton.svelte';

    import { store } from '../store';
</script>